var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscover = function SvgDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.892%",
    y1: "83.621%",
    x2: "11.077%",
    y2: "20.762%",
    id: "discover_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2ACFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5DCFF",
    stopOpacity: 0.247,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.875 .875)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6F40EE",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "url(#discover_svg__a)",
    strokeWidth: 0.563,
    fillOpacity: 0.042,
    fill: "#6F40EE",
    cx: 9,
    cy: 9,
    r: 8.719
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.725 6.627 12.1 5.278a.499.499 0 0 1 .623.623l-1.349 4.374a1.662 1.662 0 0 1-1.098 1.098L5.9 12.722a.499.499 0 0 1-.623-.623l1.349-4.374a1.662 1.662 0 0 1 1.098-1.098Z",
    fill: "#FFF"
  })))));
};
export default SvgDiscover;